import React from 'react';

import { MAILTO } from '../../site';
import ArrowIcon from '../ui/ArrowIcon';
import Reveal from '../ui/Reveal';
import NetworkCanvas from './NetworkCanvas';
import './hero.scss';

const STATS = [
  { num: '3', label: 'core disciplines: data, dev, AI' },
  { num: 'Fixed', label: 'scope, timeline & price' },
  { num: '2-4wk', label: 'typical time to first sprint' },
];

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__grid-lines" aria-hidden="true" />
      <div className="hero__glow" aria-hidden="true" />

      <div className="wrap hero__inner">
        <div className="hero__copy">
          <Reveal>
            <p className="eyebrow hero__eyebrow">Data · Dev · AI</p>
          </Reveal>

          <Reveal delay={60}>
            <h1>
              Senior data, dev &amp; AI teams for <em>growing US businesses.</em>
            </h1>
          </Reveal>

          <Reveal delay={120}>
            <p className="hero__lead">
              BizVision Tech gives small and mid-size businesses the same caliber of
              engineering talent large enterprises hire — fast to start, easy to scale, and
              scoped so there are no surprises later.
            </p>
          </Reveal>

          <Reveal delay={180}>
            <div className="hero__ctas">
              <a href={MAILTO} className="btn btn--primary btn--on-dark">
                Book a call
                <ArrowIcon />
              </a>
              <a href="#pillars" className="btn btn--ghost btn--on-dark">
                See what we build
              </a>
            </div>
          </Reveal>

          <Reveal delay={240}>
            <dl className="hero__stats">
              {STATS.map((stat) => (
                <div className="hero__stat" key={stat.label}>
                  <dt>{stat.num}</dt>
                  <dd>{stat.label}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>

        <div className="hero__stage">
          <NetworkCanvas />
        </div>
      </div>
    </section>
  );
}
